import { Retailer, RetailerAccount } from '@promoboxx/graphql-gateway-types'

export const checkRetailerCustomFields = (retailer: Retailer) => {
  let numTotal = 0
  let numAnswered = 0

  for (const customFieldValue of retailer.customFieldValues) {
    if (customFieldValue.custom_field?.retailer_permission !== 'write') {
      continue
    }

    if (customFieldValue.custom_field?.required) {
      numTotal += 1
      if ((customFieldValue.value.length || 0) > 0) {
        numAnswered += 1
      }
    }
  }

  return {
    numTotal,
    numAnswered,
    passes: numTotal <= numAnswered,
  }
}

export const checkRetailerLocations = (
  retailer: Retailer,
  retailerAccount?: RetailerAccount | null,
) => {
  const numConnected = retailer.location_count || 0
  const numTotal = retailerAccount?.locations?.length || 0

  return {
    numConnected,
    numTotal,
    passes: numTotal <= numConnected,
  }
}
